var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 195,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 195",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118.249172 51.2326115v142.7729935h-118.249172zm0-51.2326115c0 32.6440764-26.4805096 59.124586-59.124586 59.124586s-59.124586-26.4805096-59.124586-59.124586zm19.501656 194.005605c0-32.676688 26.447898-59.124586 59.124586-59.124586s59.124586 26.48051 59.124586 59.124586zm0-51.265223v-142.740382h118.249172z",
    fill: "#03363d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/zendesk.9846212af04f3f6d2284b7d30bf2f662.svg";
export { ForwardRef as ReactComponent };